import React, { useState, useMemo, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';


const Maintenance = () => {
 

  const configItems = [
    // { name: 'Attendance Settings', to: '/maintenance/attendance' },
    { name: 'Add Role', to: '/maintenance/users' },
    { name: 'Add Plant', to: '/maintenance/plants' },
    { name: 'Add Site', to: '/maintenance/maintenance-sites' },
    { name: 'Add Vendor', to: '/maintenance/vendors' },
    {name: 'Add Material Type', to: '/maintenance/material-type' },
    // { name: 'Supervisor', to: '/maintenance/supervisor-master' },
    // { name: 'Site Settings', to: '/maintenance/sites' },
    //{ name: 'Material Settings', to: '/maintenance/stock-in' },
      // { name: 'Transport', to: '/maintenance/transport-master' },
    //{ name: 'Stock Out Settings', to: '/maintenance/stock-out' },
    // { name: 'Transport Settings', to: '/maintenance/transport' },
    
    // { name: 'Default Settings', to: '/maintenance/default' },
    // { name: 'Gallery Settings', to: '/maintenance/gallery' },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Maintenance</h1>
       
      </div>
      <div className="grid grid-cols-12 gap-4 mt-4">
      <div className="col-span-12 lg:col-span-2 xl:col-span-2">
      <div className="grid grid-cols-1 gap-2">
        {configItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="block rounded-lg border hover:border-primary transition-colors bg-white p-3 shadow-sm hover:shadow"
          >
            <div className="flex items-center justify-between">
              <span className="font-medium text-gray-900">{item.name}</span>
         
            </div>
          </Link>
        ))}
        </div>
      </div>

      <div className="col-span-12 lg:col-span-10 min-w-0">
        <Outlet />
      </div>
       </div>

         

     
    </div>
  );
};

export default Maintenance;

